<template>
  <div>
    <div class="nav">
      <div class="main">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>立体教材详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div>
      <div class="main bgmain">
        <div class="detMain">
          <el-row :gutter="50">
            <el-col :span="7">
              <div class="grid-content bg-purple">
                <div class="courseCover">
                  <img :src="Info.teamatCoverlogo" alt />
                </div>
                <div class="star" style="color: #f60" @click="collect(1)" v-if="collectionFlag == 0">
                  <i class="el-icon-star-on" style="color: #f60"></i>
                  收藏
                </div>
                <div class="star" @click="collect(0)" v-if="collectionFlag == 1">
                  <i class="el-icon-star-off"></i>
                  取消收藏
                </div>
              </div>
            </el-col>
            <el-col :span="17">
              <div class="grid-content bg-purple">
                <div class="title">{{ Info.teamatName }}</div>
                <div class="info">
                  <div class="left">书名：{{ Info.teamatName }}</div>
                  <div class="right">
                    出版/修订时间：{{ Info.teamatPublishtime }}
                  </div>
                </div>
                <div class="info">
                  <div class="left">作者：{{ Info.teamatAuthor }}</div>
                  <div class="right">ISBN：{{ Info.teamatIsbn }}</div>
                </div>
                <div class="info">
                  <div class="left">出 版 社：{{ Info.teamatPress }}</div>
                  <div class="right">定价：{{ Info.teamatMoney }}</div>
                </div>
                <div class="info">
                  <div class="left">开 本：{{ Info.teamatOpenbook }}</div>
                  <div class="right">印 次：{{ Info.teamatImpression }}</div>
                </div>
                <div class="link">
                  <div>在线课程链接：</div>
                  <div>{{ Info.teamatLink }}</div>
                </div>
                <div class="tip">注：点击课程链接可进行相关课程资源学习</div>
                <div class="operation">
                  <div @click="watchOnline()">在线阅读</div>
                  <div v-if="showvideo" @click="viewInfoVideo()">
                    查看简介视频
                  </div>
                  <div v-if="sampleStatus == 2">已审核</div>
                  <div v-else-if="sampleStatus == 1">正在审核</div>

                  <div @click="demoApply()" v-else>样书申请</div>

                  <div @click="matdown()">资源包下载</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="detMain">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="简介" name="first">
              <div class="catalog">
                <div class="line"></div>
                <div class="catalogTit">简介</div>
              </div>
              <div class="catalogText" v-html="Info.teamatIntro"></div>
            </el-tab-pane>
            <el-tab-pane label="目录" name="three">
              <div class="catalog">
                <div class="line"></div>
                <div class="catalogTit">目录</div>
              </div>
              <div v-html="catalogText" class="catalogItem"></div>
            </el-tab-pane>
            <el-tab-pane label="测试" name="second">
              <div class="catalog">
                <div class="line"></div>
                <div class="catalogTit">测试</div>
              </div>
              <div v-for="(item, index) in catalog" :key="index">
                <div class="contents">
                  <div class="contentsTit">{{ item.teachaName }}</div>
                  <div class="btn" @click="test(item.fid)">开始测试</div>
                </div>
                <!-- <div
                  class="contentsInfo"
                  v-for="(small,index) in item.teamatSmallchapters"
                  :key="index"
                >
                  <div>{{small.teasmaName}}</div>
                </div>-->
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="教案" name="third">
              <div class="catalog">
                <div class="line"></div>
                <div class="catalogTit">教案</div>
            </div>-->
            <!-- <div class="matNav">
              <div class="dataTime">
                <span>最近上传</span>
                <i class="el-icon-caret-top iconTop"></i>
                <i class="el-icon-caret-bottom iconBot"></i>
              </div>
              <div class="dataTime">
                <span>浏览最多</span>
                <i class="el-icon-caret-top iconTop"></i>
                <i class="el-icon-caret-bottom iconBot"></i>
              </div>
            <div>-->
            <!-- <el-radio-group v-model="radio">
                  <el-radio :label="1">全部</el-radio>
                  <el-radio :label="2">教案</el-radio>
                  <el-radio :label="3">习题</el-radio>
                  <el-radio :label="4">电子课件</el-radio>
                  <el-radio :label="5">微课</el-radio>
                  <el-radio :label="6">我上传的资源包</el-radio>
                </el-radio-group>
            </div>-->
            <!-- <div class="search">
                <input type="text" placeholder="请输入你要搜索的教材名称" />
              </div>
              <div class="searchBut">搜索</div>
            </div>-->
            <!-- <div class="uploadMat">
              <div>上传资源包</div>
              <div>资源包可上传微课类、文本类、网页课件、PPT文档等资源</div>
            </div>-->
            <!-- <div class="matItem" v-for="(item,index) in matitem" :key="index">
                <el-row :gutter="20">
                  <el-col :span="5">
                    <div class="grid-content bg-purple itemImg">
                      <img src="../../assets/img/matItem.png" alt />
                    </div>
                  </el-col>
                  <el-col :span="19">
                    <div class="grid-content bg-purple">
                      <div class="itemTit">
                        <div>新突破大学英语综合教材</div>
                        <div>在线下载</div>
                      </div>
                      <div class="itemInfo">文字格式:TXT</div>
                      <div class="itemInfo">文件大小：100kb 上传者：李阳老师</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>-->
            <!-- <el-tab-pane label="教案" name="four"></el-tab-pane> -->
            <el-tab-pane :label="item.typeName" :name="item.fid" v-for="(item, index) in typeList" :key="index">
              <div class="matItem" v-for="(item, index) in resPackage" :key="index" v-show="showItem">
                <el-row :gutter="20">
                  <el-col :span="5">
                    <div class="grid-content bg-purple itemImg">
                      <img src="../../assets/img/matItem.png" alt />
                    </div>
                  </el-col>
                  <el-col :span="19">
                    <div class="grid-content bg-purple">
                      <div class="itemTit">
                        <div>{{ item.name }}</div>
                        <div @click="resdownload(item.filePath)">在线下载</div>
                      </div>
                      <div class="itemInfo">文字格式:{{ item.typeFlag }}</div>
                      <div class="itemInfo">文件大小：{{ item.fileSize }}</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div v-show="showmsg" class="message">{{ message }}</div>
              <div class="block" v-if="showItem">
                <el-pagination :current-page="1" @current-change="handleCurrentChange" :page-size="pageBean.pageSize"
                  layout="total, prev, pager, next" :total="total">
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="微课" name="seven">
              <div class="catalog">
                <div class="line"></div>
                <div class="catalogTit">微课</div>
              </div>
              <div v-for="(item, index) in MicroCourseList" :key="index">
                <div class="contents">
                  <div class="contentsTit">{{ item.microName }}</div>
                  <!-- <div class="btn">开始测试</div> -->
                </div>
                <div class="convideo" v-for="(sitem, index) in item.courseFile" :key="index">
                  <div>{{ sitem.fileName }}</div>
                  <div @click="MicroCourse(sitem.fileName, sitem.filePath)">
                    <img src="../../assets/img/videologo.png" alt />
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <!-- //// -->
          <!-- 样书申请 -->
          <el-dialog title :visible.sync="demodialogVisible" width="30%" :before-close="handleClose" center>
            <div class="sample">
              <div>{{ statusText }}</div>
              <div @click="demodialogVisible = false">退出</div>
            </div>
          </el-dialog>
          <!-- /样书申请 -->
          <!-- 教师账号样书申请-->
          <el-dialog title :visible.sync="matdialogVisible" width="50%" :before-close="handleClose">
            <div class="matbox">
              <div class="matTip">
                请将以下项目填写完整，更多帮助请咨询：联系电话：15638881604
              </div>
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="书名">
                  <el-input v-model="Info.teamatName" disabled></el-input>
                </el-form-item>
                <el-form-item label="书号(ISBN)">
                  <el-input v-model="Info.teamatIsbn" disabled></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                  <el-input v-model="resName" disabled></el-input>
                </el-form-item>
                <el-form-item label="手机">
                  <el-input v-model="resPhone" disabled></el-input>
                </el-form-item>
                <el-form-item label="工号">
                  <el-input v-model="resjobNum" disabled></el-input>
                </el-form-item>
                <el-form-item label="学校">
                  <el-input v-model="resSchName" disabled></el-input>
                </el-form-item>
                <el-form-item label="院系">
                  <el-input v-model="ruleForm.department" placeholder="请输入您的院系"></el-input>
                </el-form-item>
                <el-form-item label="职务">
                  <el-input v-model="ruleForm.post" placeholder="请输入您的职务"></el-input>
                </el-form-item>
                <!-- <el-form-item label="职称" prop="name">
                  <el-input v-model="ruleForm.name" placeholder="请输入您的职称"></el-input>
                </el-form-item>-->

                <el-form-item label="邮箱">
                  <el-input v-model="ruleForm.email" placeholder="请输入您的邮箱"></el-input>
                </el-form-item>
                <!-- <el-form-item label="QQ" prop="name">
                  <el-input v-model="ruleForm.name" placeholder="请输入您的QQ"></el-input>
                </el-form-item>-->
                <el-form-item label="主授课程">
                  <el-input v-model="ruleForm.teaCourse" placeholder="请输入您的主授课程"></el-input>
                </el-form-item>

                <el-form-item label="寄送地址">
                  <el-input v-model="ruleForm.senDarea" placeholder="请输入您的详细样书寄送地址"></el-input>
                </el-form-item>
                <!-- <el-form-item label="邮编" prop="name">
                  <el-input v-model="ruleForm.name" placeholder="请输入您的邮编"></el-input>
                </el-form-item>-->
                <el-form-item label="备注">
                  <el-input resize="none" type="textarea" v-model="ruleForm.remarks"
                    placeholder="请填写您的样书书名-作者（每学期1-2本）"></el-input>
                </el-form-item>
                <!-- <div class="userInfo">
            <div>
              <div class="InfotTit">姓 名：</div>
              <input type="text" placeholder="请输入您的姓名" />
            </div>
          </div>
          <div class="userInfo">
            <div>
              <div class="InfotTit">电 话：</div>
              <input type="text" placeholder="请输入您的电话" />
            </div>
          </div>
          <div class="userInfo">
            <div>
              <div class="InfotTit">邮 箱：</div>
              <input type="mail" placeholder="请输入您的邮箱" />
            </div>
                </div>-->
                <!-- <div class="message">
            <div>留 言：</div>
            <div>
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>
            </div>
                </div>-->
                <div class="subbut" @click="apply()">提交信息</div>
                <!-- <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button> -->
                <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
              </el-form>
            </div>
          </el-dialog>
          <!-- /教师账号样书申请 -->
          <!-- 微课播放器 -->
          <el-dialog :title="microTitle" :visible.sync="dialogVisible" width="30%">
            <div class="player">
              <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
                style="object-fit: fill" :options="playerOptions" :x5-video-player-fullscreen="true"
                @pause="onPlayerPause($event)" @play="onPlayerPlay($event)"
                @fullscreenchange="onFullscreenChange($event)" @click="fullScreen" id="video1"></video-player>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
          </el-dialog>

          <el-dialog class="dialog" title="教材详情" :visible.sync="dialogVisiblepdf" width="962px">
            <div class="el-dialog-div">
              <div style="text-align: center" v-if="loading">
                <i class="el-icon-loading"></i>
                <p>文件加载中</p>
              </div>
              <canvas v-for="page in pages" :id="'canvas' + page" :key="page"></canvas>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    api
  } from '../../assets/api/axios'
  import {
    mapMutations,
    mapState,
    mapGetters
  } from 'vuex'
  import PDF from 'pdfjs-dist'
  import {
    Loading
  } from 'element-ui'
  export default {
    data() {
      return {
        activeName: 'first',
        radio: 3,
        matitem: [{
          id: 1
        }, {
          id: 1
        }, {
          id: 1
        }, {
          id: 1
        }, {
          id: 1
        }],
        demodialogVisible: false,
        matdialogVisible: false,
        textarea: '',
        dialogVisible: false,
        playerOptions: {
          //playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: 'video/mp4',
            src: 'http://wutonghua-oss.oss-cn-qingdao.aliyuncs.com/jiaofa/onlinechapter/03墙下带形基础.mp4',
          }, ],
          poster: '',
          width: '',
          notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            // timeDivider: true,
            // durationDisplay: true,
            // remainingTimeDisplay: false,
            fullscreenToggle: true, //全屏按钮
          },
        },
        ruleForm: {
          teamaterialId: '', //教材ID
          phone: '',
          schName: '',
          department: '',
          post: '',
          email: '',
          teaCourse: '',
          senDarea: '',
          jobNum: '',
        },
        rules: {
          name: [{
            required: true,
            message: '请输入活动名称',
            trigger: 'blur'
          }],
        },
        Info: {},
        fid: '',
        catalog: [],
        typeList: [],
        total: 0,
        pageBean: {
          pageNum: 1,
          pageSize: 5,
          typeId: '',
          teamatId: '',
        },
        resPackage: [],
        message: '',
        showmsg: false,
        showItem: true,
        MicroCourseList: [],
        microTitle: '',
        enableApply: '',
        sampleStatus: '',
        collectionFlag: 0,
        statusText: '抱歉，由于权限问题，样书申请只限老师账号,请进行教师认证~',
        resbtu: false,
        res: true,
        catalogText: '',
        activeId: '',
        showvideo: false,
        pdfDoc: null,
        pages: 0,
        dialogVisiblepdf: false,
        loading: true,
        onOff: false,
        userType: '',
      }
    },
    watch: {
      dialogVisible: function(val) {
        console.log(val)
        if (val == false) {
          this.$refs.videoPlayer.player.pause()
        }
      },
    },
    created() {
      this.getInfo()
      this.gettypeId()
      let token = window.localStorage.getItem('token')
      if (token == '' || token == null) {
        console.log(123)
      } else {
        this.isEnableApply()
      }
    },
    mounted() {
      this.url =
        'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf'
    },
    computed: {
      ...mapGetters([
        'resPhone',
        'resFid',
        'resStatus',
        'resSchName',
        'resName',
        'resjobNum',
        'restypeFlag',
        'resschType',
      ]),
    },
    methods: {
      loadFile(url) {
        PDF.getDocument(url).then((pdf) => {
          console.log(11111)
          this.pdfDoc = pdf
          this.pages = this.pdfDoc.numPages
          this.$nextTick(() => {
            this.renderPage(1)
          })
        })
      },
      /*
       * 渲染PDF文件
       * */
      renderPage(num) {
        this.pdfDoc.getPage(num).then((page) => {
          let canvas = document.getElementById('canvas' + num)
          let ctx = canvas.getContext('2d')
          let dpr = window.devicePixelRatio || 1 // 设备像素比
          let bsr =
            ctx.webkitBackingStorePixelRatio ||
            ctx.mozBackingStorePixelRatio ||
            ctx.msBackingStorePixelRatio ||
            ctx.oBackingStorePixelRatio ||
            ctx.backingStorePixelRatio ||
            1 // 浏览器在渲染canvas之前会用几个像素来来存储画布信息,类似img
          let ratio = dpr / bsr
          let viewport = page.getViewport(1.5)
          canvas.width = viewport.width * ratio // 画布大小,默认值是width:300px,height:150px
          canvas.height = viewport.height * ratio
          canvas.style.width = viewport.width + 'px' // 画布的框架大小
          canvas.style.height = viewport.height + 'px'
          let renderContext = {
            canvasContext: ctx,
            viewport: viewport,
          }
          page.render(renderContext)
          if (this.pages > num) {
            this.renderPage(num + 1)
          } else {
            this.loading = false
            this.onOff = true
            // this.closeServerLoadingHandle()
          }
        })
      },
      async getInfo() {
        let fid = this.$route.query.fid
        this.fid = fid
        let res = await api.post('/front/teamaterial/searchDetailByFid', {
          fid: fid,
        })
        console.log(res)
        this.Info = res.data
        if (res.data.teamatDetailsvideo) {
          this.showvideo = true
        }
      },
      async getTest() {
        let res = await api.post('/front/teamaterial/lookCatalog', {
          fid: this.fid,
        })
        console.log(res)
        this.catalog = res.data
      },
      // get 教案id
      async gettypeId() {
        let res = await api.post('/front/teamaterial/getTypesId')
        // console.log(res)
        this.typeList = res.data
      },
      handleCurrentChange(val) {
        this.pageBean.pageNum = val
        this.getResPackage(this.activeId)
      },
      async getResPackage(typeId) {
        this.pageBean.teamatId = this.fid
        this.pageBean.typeId = typeId
        let res = await api.post(
          '/front/teamaterial/getResPackage',
          this.pageBean
        )
        // console.log(res)
        if (res.code === 1000) {
          this.showItem = true
          this.showmsg = false
          this.resPackage = res.data.list
          this.total = res.data.total
        }
        if (res.code === 600) {
          this.message = res.msg
          this.showmsg = true
          this.showItem = false
        }
      },
      resdownload(url) {
        if (!localStorage.getItem('token')) {
          this.$message.warning('请先登录')
          return false
        }
        try {
          var elemIF = document.createElement('iframe')
          elemIF.src = url
          elemIF.style.display = 'none'
          document.body.appendChild(elemIF)
        } catch (e) {
          alert('下载异常！')
        }
      },
      async getMicroCourseList() {
        let res = await api.post('/front/micro_course/getMicroCourseList', {
          tid: this.fid,
        })
        console.log(res)
        this.MicroCourseList = res.data
      },
      MicroCourse(fileName, filePath) {
        this.dialogVisible = true
        this.microTitle = fileName
        this.playerOptions.sources[0].src = filePath
      },
      viewInfoVideo() {
        this.dialogVisible = true
        this.playerOptions.sources[0].src = this.Info.teamatDetailsvideo
      },
      async watchOnline() {
        let res = await api.post('/front/teamaterial/watchOnline', {
          fid: this.fid,
        })
        if (res.code == 2000) {
          this.$message.warning('没有在线文档')
        } else {
          // const fileurl = `https://wthedu.51suiyixue.com/PDF/web/viewer.html?file=${encodeURIComponent(res.data)}`
          // window.open(fileurl)
          if (!this.onOff) {
            this.loadFile(res.data)
          }
          this.dialogVisiblepdf = true
        }
      },
      async demoApply() {
        if (!localStorage.getItem('token')) {
          this.$message.warning('请先登录')
          return false
        }
        if (this.userType == 0) {
          this.$message.warning('您不是教师用户,不能申请!')
          return
        }
        if (this.resStatus == 1) {
          this.demodialogVisible = true
          this.statusText = '正在进行教师认证审核请耐心等待!'
          return
        }
        if (this.enableApply == 0) {
          this.matdialogVisible = true
        } else if (this.enableApply == 1) {
          this.demodialogVisible = true
          this.statusText = '已申请不能重复申请!'
        }
      },
      async isEnableApply() {
        let res = await api.post('/front/teamaterial/isEnableApply', {
          fid: this.fid,
        })
        console.log('状态', res)
        this.sampleStatus = res.data.sampleStatus
        this.enableApply = res.data.enableApply
        this.collectionFlag = res.data.collectionFlag
        this.userType = res.data.userType
      },
      async apply() {
        this.ruleForm.teamaterialId = this.fid
        let res = await api.post(
          '/front/teamaterial/sampleBookApply',
          this.ruleForm
        )
        console.log(res)
        if (res.code == 1000) {
          this.$message.success('提交成功')
          this.matdialogVisible = false
        } else {
          this.$message.error('提交失败，请重新提交')
        }
      },
      async collect(num) {
        let token = window.localStorage.getItem('token')
        if (token == '' || token == null) {
          this.$message.warning('请登录后收藏！')
        } else {
          let res = await api.post('/front/teamaterial/collection', {
            fid: this.fid,
            types: 2,
            isCollection: num,
          })
          console.log('收藏', res)
          if (res.code == 1000) {
            this.collectionFlag = num
          }
        }
      },
      async getcatalog() {
        let res = await api.post('/front/teamaterial/catalogInfo.do', {
          fid: this.fid,
        })
        console.log(res)
        this.catalogText = res.data
      },
      async getPersonData() {
        var res = await api.post('/front/personal/myMessage')
        // let resschType = res.data.schType
        let restypeFlag = res.data.typeFlag
        let personStatus = res.data.status

        if (restypeFlag == 0) {
          this.$message.warning('没有权限，您不是老师账号')
        } else if (personStatus == 1) {
          this.$message.warning('请联系管理员进行审核')
        } else if (personStatus == 0) {
          this.$message.warning('请先进行教师认证')
        } else {
          let teamatId = this.fid
          if (location.hostname == 'localhost') {
            window.location.href =
              `http://192.168.1.11:8091/front/teamaterial/resPackageDownload?teamatId=${teamatId}`
          } else {
            window.location.href =
              `https://wthedu.51suiyixue.com/youshiyouku/front/teamaterial/resPackageDownload?teamatId=${teamatId}`
          }
        }

        // if (personStatus != 0) {
        //   this.$message.warning('没有权限，您是非合作院校老师')
        // } else if (restypeFlag == 0 || personStatus == 1) {
        //   this.$message.warning('没有权限，您不是老师账号，请进行教师认证')
        // } else if (restypeFlag == 1 && personStatus == 0) {
        //   let teamatId = this.fid
        //   if (location.hostname == 'localhost') {
        //     window.location.href = `http://192.168.1.11:8091/front/teamaterial/resPackageDownload?teamatId=${teamatId}`
        //   } else {
        //     window.location.href = `https://wthedu.51suiyixue.com/youshiyouku/front/teamaterial/resPackageDownload?teamatId=${teamatId}`
        //   }
      },
      matdown() {
        this.getPersonData()
      },
      // 开始测试
      test(fid) {
        this.$router.push({
          path: '/teachingmat/Matdetails/chaptertest',
          query: {
            fid: fid
          },
        })
      },
      handleClick(tab, event) {
        console.log(this.activeName)
        if (this.activeName == 'second') {
          this.getTest()
        } else if (this.activeName == 'first') {} else if (this.activeName == 'seven') {
          this.getMicroCourseList()
        } else if (this.activeName == 'three') {
          this.getcatalog()
        } else {
          this.pageBean.pageNum = 1
          this.getResPackage(this.activeName)
        }
        this.activeId = this.activeName
      },
      handleClose(done) {
        this.demodialogVisible = false
        this.matdialogVisible = false
      },
      // 视频方法
      fullScreen() {
        const player = this.$refs.videoPlayer.player
        player.requestFullscreen() //调用全屏api方法
        player.isFullscreen(true)
        player.play()
      },
      onPlayerPlay(player) {
        player.play()
      },
      onPlayerPause(player) {
        // alert("pause");
      },
      // 表单验证
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!')
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .el-dialog-div {
    overflow: auto;
  }

  .nav {
    width: 100%;
    height: 42px;
    background: rgba(237, 234, 231, 1);
  }

  .bgmain {
    background: #fff;
  }

  .detMain {
    margin: 0 60px 0;
    padding-bottom: 60px;
    padding-top: 30px;
  }

  .courseCover {
    height: 368px;
    width: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .star {
    margin-top: 10px;
    height: 38px;
    border: 1px solid rgba(224, 224, 224, 1);
    width: 100%;
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 40px;
    text-align: center;
  }

  .title {
    font-size: 24px;
    font-family: SourceHanSansCN;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    margin: 22px 0 40px;
  }

  .info {
    overflow: hidden;
    border-bottom: 1px dashed rgba(210, 210, 210, 1);
    height: 45px;
    line-height: 45px;

    .left {
      float: left;
      width: 330px;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
    }

    .right {
      float: left;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
    }
  }

  .link {
    width: 100%;
    min-height: 40px;
    background: rgba(245, 245, 245, 1);
    margin-top: 20px;
    line-height: 40px;
    padding-left: 10px;
    overflow: hidden;

    div:nth-child(1) {
      font-size: 14px;
      color: rgba(153, 153, 153, 1);
      float: left;
    }

    div:nth-child(2) {
      // width: 100px;
      font-size: 14px;
      color: rgba(211, 111, 22, 1);
      float: left;
    }
  }

  .tip {
    margin: 10px 0 25px;
    font-size: 13px;
    color: rgba(204, 204, 204, 1);
  }

  .operation {
    overflow: hidden;

    :nth-child(1) {
      float: left;
      width: 128px;
      height: 40px;
      background: rgba(181, 14, 5, 1);
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      text-align: center;
      margin-left: 10px;
      cursor: pointer;
    }

    :nth-child(2) {
      float: left;
      width: 128px;
      height: 40px;
      background: rgba(181, 14, 5, 1);
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      text-align: center;
      margin-left: 10px;
      cursor: pointer;
    }

    :nth-child(3) {
      float: left;
      width: 128px;
      height: 40px;
      background: rgba(181, 14, 5, 1);
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      text-align: center;
      margin-left: 10px;
      cursor: pointer;
    }

    :nth-child(4) {
      float: left;
      width: 128px;
      height: 40px;
      background: rgba(181, 14, 5, 1);
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      text-align: center;
      margin-left: 10px;
      cursor: pointer;
    }
  }

  .catalog {
    overflow: hidden;
    margin: 20px 0;

    .line {
      width: 3px;
      height: 14px;
      background: rgba(181, 14, 5, 1);
      float: left;
    }

    .catalogTit {
      font-size: 14px;
      font-weight: 500;
      color: rgba(181, 14, 5, 1);
      margin-left: 8px;
    }
  }

  .catalogText {
    margin-top: 20px;
    font-size: 13px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 24px;
  }

  .contents {
    overflow: hidden;

    .contentsTit {
      margin: 30px 0 20px;
      float: left;
      font-size: 16px;
      font-family: SourceHanSansCN;
      font-weight: 700;
      color: rgba(102, 102, 102, 1);
    }

    .btn {
      float: right;
      width: 82px;
      height: 30px;
      border: 1px solid rgba(224, 224, 224, 1);
      color: rgba(102, 102, 102, 1);
      background-color: none;
      line-height: 30px;
      text-align: center;
      cursor: pointer;

      &:hover {
        color: rgba(181, 14, 5, 1);
      }
    }
  }

  .contentsInfo {
    div {
      font-size: 13px;
      color: rgba(102, 102, 102, 1);
      line-height: 35px;
    }
  }

  .convideo {
    height: 35px;
    overflow: hidden;

    div:nth-child(1) {
      font-size: 13px;
      color: rgba(102, 102, 102, 1);
      float: left;
    }

    div:nth-child(2) {
      float: right;
    }
  }

  .matNav {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    display: float;
    margin-top: 20px;
    overflow: hidden;
    height: 70px;
    line-height: 40px;

    div {
      float: left;
    }

    .signUp {
      position: relative;
    }

    .iconTop {
      position: absolute;
      top: 9px;
      right: -15px;

      &:hover {
        color: #0b3450;
      }
    }

    .iconBot {
      position: absolute;
      bottom: 9px;
      right: -15px;

      &:hover {
        color: #0b3450;
      }
    }

    .dataTime {
      position: relative;
      margin-right: 30px;
    }

    .search {
      width: 190px;
      height: 34px;
      margin-right: 20px;

      input {
        border: none;
        background: rgba(0, 0, 0, 0.1);
        width: 190px;
        height: 34px;
        padding-left: 10px;
      }
    }

    .searchBut {
      width: 77px;
      height: 34px;
      background: rgba(181, 14, 5, 1);
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      line-height: 34px;
      text-align: center;
      float: right;
      margin-top: 4px;
    }
  }

  .uploadMat {
    overflow: hidden;

    :nth-child(1) {
      float: left;
      width: 180px;
      height: 42px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(224, 224, 224, 1);
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      line-height: 42px;
      text-align: center;
    }

    :nth-child(2) {
      float: left;
      height: 42px;
      line-height: 42px;
      color: rgba(153, 153, 153, 1);
      font-size: 12px;
      margin-left: 20px;
    }
  }

  .matItem {
    margin-top: 20px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 20px;

    .itemImg {
      width: 100%;
      height: 86px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .itemTit {
      overflow: hidden;
      margin: 10px 0 20px;

      :nth-child(1) {
        float: left;
        font-size: 14px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }

      :nth-child(2) {
        float: right;
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
    }

    .itemInfo {
      font-size: 13px;
      color: rgba(102, 102, 102, 1);
      line-height: 24px;
    }
  }

  .sample {
    :nth-child(1) {
      margin: 0 auto;
      text-align: center;
      margin-bottom: 60px;
    }

    :nth-child(2) {
      margin: 0 auto;
      width: 360px;
      height: 36px;
      background: rgba(181, 14, 5, 1);
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 36px;
      text-align: center;
      margin-bottom: 40px;
    }
  }

  .matbox {
    margin: 0 30px;

    .matTip {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      // margin-bottom: 20px;
      margin: 0 0 20px 30px;
    }

    .userInfo {
      overflow: hidden;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);

      .InfotTit {
        float: left;
        line-height: 40px;
      }

      input {
        float: left;
        width: 496px;
        height: 40px;
        border: 1px solid rgba(237, 237, 237, 1);
        padding-left: 15px;
        margin-bottom: 10px;

        &::placeholder {
          font-size: 14px;
          color: rgba(204, 204, 204, 1);
        }
      }
    }

    .message {
      overflow: 'hidden';
      height: 160px;

      :nth-child(1) {
        float: left;
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
      }

      :nth-child(2) {
        float: left;
      }
    }

    .subbut {
      height: 36px;
      background: rgba(181, 14, 5, 1);
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 36px;
      margin: 20px 0 20px;
    }
  }

  .message {
    font-size: 18px;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
    line-height: 24px;
    margin: 40px 40px 200px;
  }
</style>
<style lang="scss">
  @import '../../assets/css/mattabs.scss';

  .catalogItem {
    line-height: 30px;
  }
</style>